import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  BuyflowConfigLimits,
  BuyflowVesselSortConfig,
  VesselSortOption,
} from '../../shared/buyflow-sort-filter-control/buyflow-sort-filter-control.component';
import { Moment } from 'moment';

@Component({
  selector: 'app-buyflow-sort-filter-dialog',
  templateUrl: './buyflow-sort-filter-dialog.component.html',
  styleUrls: ['./buyflow-sort-filter-dialog.component.scss'],
})
export class BuyflowSortFilterDialogComponent implements OnInit, OnDestroy {
  limits: BuyflowConfigLimits;
  sortFilterConfig: Partial<BuyflowVesselSortConfig> = {};
  sortType: string[];
  previousConfigValues: BuyflowVesselSortConfig;
  previousSortValue: string[];
  availableOn: Moment;

  constructor(
    public dialogRef: MatDialogRef<BuyflowSortFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.limits = data.limits;
    this.previousConfigValues = data.previousConfigValues;
    this.previousSortValue = data.previousSortValue;
    this.availableOn = data.availableOn;
  }

  sortEmit(sortType: string[]): void {
    this.sortType = sortType;
  }

  ngOnInit() {
    if (this.previousSortValue) {
      this.sortType = this.previousSortValue;
    }
    if (this.previousConfigValues) {
      this.sortFilterConfig = this.previousConfigValues;
    } else {
      this.sortFilterConfig = {
        priceMin: this.limits.halfDayMinPrice,
        priceMax: this.limits.halfDayMaxPrice,
        passengers: this.limits.minPassengers,
        boatLengthMin: this.limits.minBoatLength,
        boatLengthMax: this.limits.maxBoatLength,
        cabins: this.limits.minCabins,
        showers: this.limits.minShowers,
        sleeps: this.limits.minSleeps,
        bathrooms: this.limits.minBathrooms,
        categories: [],
      };
    }
  }

  ngOnDestroy() {}

  dismiss(clearClick: boolean): void {
    this.dialogRef.close({
      sort: this.sortType,
      filters: this.sortFilterConfig,
      clearClick: clearClick,
    });
  }

  filterEmit($event: BuyflowVesselSortConfig) {
    this.sortFilterConfig = $event;
  }
}

export interface MobileSortConfig {
  sort: string[];
  filters: BuyflowVesselSortConfig;
  clearClick: boolean;
}
